 import { useEffect, useState } from "react";

import Banner from "./Banner"; 
import PopularTours from "./PopularTours";
import HomeTestimonials from "./HomeTestimonials";
//  import Services from "./Services";
import WhyChoose from "./WhyChoose";
import OurServices from "./OurServices";
import OurCars from "./OurCars";
import VaranasiTours from "./VaranasiTours";
import axios from "axios";
import { MyApi } from "../../MyApi";
import BookYourTaxi from "../BookYourTaxi";

export default function Home() {
  const [setting, setSetting] = useState(null);

  // ✅ API call
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + "site-setting",
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data?.status) {
          setSetting(res.data.data);
        }
      } catch (error) {
        console.error("Setting API error:", error);
      }
    };

    fetchSetting();
  }, []);
  return (
    <div>
      <Banner />
      <BookYourTaxi/>
      <OurCars  setting={setting} /> 
      <VaranasiTours />
      <OurServices />
      <PopularTours />
      <HomeTestimonials />
       <WhyChoose/>
    </div>
  );
}
